export const getFileIcon = (file) => {
    const ext = file.name.split('.').pop()?.toLowerCase();
    if (ext === 'pdf')
        return 'custom:pdf-icon';
    if (ext === 'xls' || ext === 'xlsx')
        return 'custom:excel-icon';
    if (ext === 'doc' || ext === 'docx')
        return 'custom:word-icon';
    if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext || ''))
        return 'akar-icons:image';
    if (['xls', 'xlsx', 'csv'].includes(ext || ''))
        return 'custom:excel-icon';
    if (ext === 'mp4')
        return 'mdi:video';
    return 'mdi:file';
};
